import AdminLayout from '../../components/feature/AdminLayout';
import FlagsTable from './components/FlagsTable';

export default function FeatureFlagsPage() {
  return (
    <AdminLayout>
      <FlagsTable />
    </AdminLayout>
  );
}
